/**
 * Created by Jie Gao on 25/01/19.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {StarStruck} from "../StarStruck";
import {StarStruckParsedGameData} from "../server/data/StarStruckParsedGameData";
import {StarStruckGameModuleConfig} from "../StarStruckGameModuleConfig";

export class StopHotZoneController extends ReelStopPresentationController {

    private _bonusFeatureTriggered:boolean = false;
    constructor(index:number) {
        super(index, "StopHotZoneController");
    }

    protected parseFeatureGameData(data:StarStruckParsedGameData):void {
        this._bonusFeatureTriggered = data.bonusFeatureTriggered;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(!this.tryPlayBouncePresentation(data)) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private tryPlayBouncePresentation(data:IReelStoppedData):boolean {
        if(data.reelId === 1 && !this._bonusFeatureTriggered){
            StarStruckGameModuleConfig.hotZone.hide(data.fastSpin || data.quickStop);
            this.dispatchCompleteEvent(data.reelId);
            return true;
        }
        return false;
    }
}
